/* PWW v56 mobile dropdown fix + cache-busted asset.
   Enables tap/click dropdown menus on touch/mobile where hover is not available. */
(function () {
  function closePwwDropdowns(except) {
    document.querySelectorAll('.pww-nav-dropdown.is-open').forEach(function (item) {
      if (except && item === except) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector('.pww-nav-trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function initPwwMobileDropdowns() {
    var nav = document.querySelector('.pww-nav');
    if (!nav || nav.dataset.pwwDropdownsReady === 'true') return;
    nav.dataset.pwwDropdownsReady = 'true';

    nav.querySelectorAll('.pww-nav-dropdown').forEach(function (item) {
      var trigger = item.querySelector('.pww-nav-trigger');
      var menu = item.querySelector('.pww-dropdown-menu');
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        closePwwDropdowns(item);
        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      menu.addEventListener('click', function (event) {
        if (event.target && event.target.closest('a')) {
          closePwwDropdowns();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.pww-nav-dropdown')) closePwwDropdowns();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePwwDropdowns();
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 991px)').matches) closePwwDropdowns();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPwwMobileDropdowns);
  } else {
    initPwwMobileDropdowns();
  }
})();
